import Link from "next/link";


export default function NFLink({ children, href, ...props }){


    const storeCode = props?.storeCode || 'en_US';

    const countryCode = storeCode.split('_')[1].toLowerCase();
    let langCode = null;
    if(countryCode==='ww'){
        langCode = storeCode.split('_')[0].toLowerCase();
    }else{
        langCode = `${storeCode.split('_')[0].toLowerCase()}-${countryCode}`;
    }

    // remove storeCode from props
    delete props.storeCode;

    return (
        <Link prefetch={false} hrefLang={langCode} href={href} {...props}>
            {children}
        </Link>
    );
    
}